import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor to handle unauthorized errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Clear local storage on unauthorized
      localStorage.removeItem('token');
      localStorage.removeItem('user');

      // Redirect to login if on protected page or trying to perform protected action
      // We check if we're already on /auth to avoid infinite loop
      if (window.location.pathname !== '/auth') {
        window.location.href = '/auth';
      }
    }
    return Promise.reject(error);
  }
);

// Helper function to convert relative upload paths to full backend URLs
export const getImageUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  if (path.startsWith('/upload') || path.startsWith('/uploads')) {
    return `${BACKEND_URL}${path}`;
  }
  return path;
};

export const getBanners = (lang = 'ru') => {
  return api.get(`/banners?lang=${lang}`);
};

export const getJobs = (lang = 'all', options = {}) => {
  const params = new URLSearchParams();
  if (lang) {
    params.append('lang', lang);
  }
  if (options.limit) {
    params.append('limit', options.limit);
  }
  if (options.category) {
    params.append('category', options.category);
  }
  if (options.type) {
    params.append('type', options.type);
  }
  if (options.author) {
    params.append('author', options.author);
  }
  return api.get(`/jobs?${params.toString()}`);
};

export const getUserPublicProfile = (userId) => {
  return api.get(`/users/${userId}`);
};



export const getChatMessages = () => {
  return api.get('/chat-messages');
};

export const getVideoBanners = (lang = 'ru') => {
  return api.get(`/video-banners?lang=${lang}`);
};

export const getCountries = () => {
  return api.get('/countries');
};

export const submitContactForm = (data) => {
  return api.post('/contact', data);
};

export const register = (data) => {
  return api.post('/auth/register', data);
};

export const login = (data) => {
  return api.post('/auth/login', data);
};

export const getCaptcha = () => {
  return api.get('/auth/captcha');
};

export const updateProfile = (formData) => {
  return api.put('/auth/profile', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    }
  });
};

export const createJob = (formData) => {
  return api.post('/jobs', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    }
  });
};

export const getUserJobs = () => {
  return api.get('/jobs/me');
};

export const deleteJob = (jobId) => {
  return api.delete(`/jobs/${jobId}`);
};

// Profile - User Reviews
export const getUserReviews = (userId) => {
  return api.get(`/users/${userId}/reviews`);
};

export const createReview = (reviewData) => {
  return api.post('/reviews', reviewData);
};

export default api;

